import { render, staticRenderFns } from "./DestinationsSkeleton.vue?vue&type=template&id=5453a366&"
import script from "./DestinationsSkeleton.vue?vue&type=script&lang=js&"
export * from "./DestinationsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DestinationsSkeleton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports